import React from 'react';

const Footer = () => {
  return (
    <div className="container mx-auto h-card flex flex-col items-center justify-center mt-10 font-mono tracking-wider mb-1 text-center px-8 text-sm sm:text-xl">
      I designed and developed this site with:{' '}
      <a
        className="inline-block bg-indigo-700 text-white px-3 py-2 rounded mt-4"
        href="https://reactjs.org/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {' '}
        Reactjs
      </a>
      <div className="mt-8">&copy;{new Date().getFullYear()}</div>
    </div>
  );
};

export default Footer;
